import cityList from './../data/citylist.json'
import { useDispatch, useSelector } from 'react-redux'
import { pushWeather } from '../features/weather'
import { forecast5Day } from '../request'
import getTheme from './../theme';
import palette from '../palette';


export function filterList(toSearch) {
  return new Promise((resolve, reject) => {
    resolve(cityList.filter(c => c.name.toUpperCase().includes(toSearch.toUpperCase())).sort((first, second) => {
      if(first.name.toUpperCase() == toSearch.toUpperCase())
        return -1;
      return 1;
    }))
  })
  
}

export function getCityById(id) {
  for (let c of cityList) {
    if(c.id == id){
      return c      
    }
  }
  return -1
}

export function loadWeather(id) {
  return new Promise(async (resolve, reject) => {
    try {
      const dispatch = useDispatch()
      let ans = await forecast5Day(id)
      dispatch(pushWeather(ans))
      resolve()
    } catch (er) {
      reject(er)
    }
  })
}

export function getCityList() {
  return cityList.map(c => c.name)
}

export function modeSetter(mode) {

  let modemui = null

  if (mode != 'dark' && mode != 'light') {
    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
    mode = darkThemeMq.matches ? 'dark' : 'light'
  }

  if (mode == 'dark') {
    document.body.style.backgroundColor = palette.background.dark;
    document.body.style.color = palette.textColor.dark;
    modemui = getTheme('dark')
  }
  else {
    document.body.style.backgroundColor = palette.background.light;
    document.body.style.color = palette.textColor.light;
    modemui = getTheme('light')
  }

  return modemui
}